import React, { useEffect } from 'react';
import {
  arrayOf,
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { Link, Skeleton, SkeletonBlock, Typography } from '@one-thd/sui-atomic-components';

const MostSearchedStoresComponent = () => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('most-searched-stores.ready'); }, []);

  const { data, loading, error } = useDataModel('storeDirectory', {});
  const storeDirectory = data?.storeDirectory?.storeDirectory || [];

  if (loading) {
    return (
      <article data-component="MostSearchedStoresPlaceholder">
        <section>
          <Typography variant="h2" weight="display">
            Most Searched Stores
          </Typography>
        </section>
        <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
          <SkeletonBlock aspect="wide" height="900px" />
        </Skeleton>
      </article>
    );
  }
  if (!storeDirectory?.length || error) return null;

  return (
    <article data-component="MostSearchedStores">
      <section>
        <Typography variant="h2" weight="display">
          Most Searched Stores
        </Typography>
        <Typography>
          The Home Depot provides affordable and convenient home improvement resources, supplies
          and solutions through hundreds of stores located across the country.
        </Typography>
        <Typography>
          Below, you can view a list of our Most Searched Stores. Click on a store to see more
          details or use our <Link href="/l/store-locator">Store Locator</Link> to find The Home
          Depot store nearest you.
        </Typography>
      </section>

      <section className="sui-columns-2 sui-p-4 md:sui-columns-3 lg:sui-columns-6 lg:sui-gap-10">
        {storeDirectory.map(({ stateName, stateLink, mostSearchedStores }, stateIndex) => {
          return (
            <div className="sui-py-1 sui-break-inside-avoid" key={`${stateName}-${stateIndex}`}>
              <Link
                underline="none"
                className="sui-font-bold sui-py-1 sui-inline-block"
                id={`${stateName}-${stateIndex}`}
                href={stateLink}
              >
                {stateName}
              </Link>
              <ul className="sui-list-none sui-pl-4">
                {(mostSearchedStores || []).map(({ name: storeName, storeDetailsPageLink }, storeIndex) => {
                  return (
                    <li key={`${stateName}-${storeName}-${storeIndex}`}>
                      <Link
                        underline="none"
                        id={`${stateName}-${storeName}-${storeIndex}`}
                        href={storeDetailsPageLink}
                      >
                        {storeName}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </section>
    </article>
  );
};

MostSearchedStoresComponent.displayName = 'MostSearchedStores';

const dataModel = {
  storeDirectory: params().shape({
    storeDirectory: arrayOf(shape({
      stateName: stringType(),
      stateLink: stringType(),
      mostSearchedStores: arrayOf(shape({
        name: stringType(),
        storeDetailsPageLink: stringType(),
      }))
    }))
  })
};
MostSearchedStoresComponent.dataModel = dataModel;

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'most-searched-stores',
  placeholder: (
    <div data-component="MostSearchedStoresPlaceholder">
      <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
        <SkeletonBlock aspect="wide" height="900px" />
      </Skeleton>
    </div>
  ),
  scrollBuffer: 100,
}, MostSearchedStoresComponent);

const MostSearchedStores = withDynamicComponent(HydratedComponent);

MostSearchedStores.dataModel = dataModel;

export { MostSearchedStores };
